import { render, staticRenderFns } from "./CastDetailModal.vue?vue&type=template&id=12d7990a&scoped=true&"
import script from "./CastDetailModal.vue?vue&type=script&lang=js&"
export * from "./CastDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CastDetailModal.vue?vue&type=style&index=0&id=12d7990a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d7990a",
  null
  
)

export default component.exports